export default (message, $store, { MUTATION }) => {
  const { dispatch } = $store;

  dispatch('removeBotTypingOfChat', message.cid);
};
